import { render } from "./taxDeclaration.vue?vue&type=template&id=7f0f3804&scoped=true"
import script from "./taxDeclaration.vue?vue&type=script&lang=js"
export * from "./taxDeclaration.vue?vue&type=script&lang=js"

import "./taxDeclaration.vue?vue&type=style&index=0&id=7f0f3804&lang=scss"
import "./taxDeclaration.vue?vue&type=style&index=1&id=7f0f3804&lang=scss&scoped=true"
import "./taxDeclaration.vue?vue&type=style&index=2&id=7f0f3804&lang=css"

import exportComponent from "/var/jenkins_home/workspace/jk-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0f3804"]])

export default __exports__